const parseDate = (date: string): Date => {
  const dateParts = date.split(' ')
  const [year, month, day] = dateParts[0].split('-')
  const [hour, minutes, seconds] = dateParts[1].split(':')
  // Приводим время к UTC
  let intHour = parseInt(hour)
  let intDay = parseInt(day)
  intHour -= 3;
  if (intHour < 0) {
    intHour += 24
    intDay -= 1
  }
  // Месяцы в JS начинаются с 0
  let intMonth = parseInt(month)
  intMonth -= 1
  return new Date(Date.UTC(Number(year), intMonth, intDay, intHour, Number(minutes), Number(seconds)))
}

export {
  parseDate
}
